<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>用户管理</a-breadcrumb-item>
    <a-breadcrumb-item>购买记录</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row" :gutter="16" align="middle">
      <!-- 日期选择器 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="5" class="tool-title">日期：</a-col>
          <a-col :span="19">
            <a-range-picker v-model:value="dateRange" :format="dateFormat" style="width: 100%;" />
          </a-col>
        </a-row>
      </a-col>

      <!-- UID -->
      <a-col :span="4">
        <a-row>
          <a-col :span="6" class="tool-title">UID：</a-col>
          <a-col :span="18">
            <a-input v-model:value="uid" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>

      <!-- 支付渠道 -->
      <a-col :span="5">
        <a-row>
          <a-col :span="6" class="tool-title">支付渠道：</a-col>
          <a-col :span="18">
            <a-select v-model:value="payChannel" placeholder="请选择" style="width: 100%;">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option :value="1">Google Pay</a-select-option>
              <a-select-option :value="2">Apple Pay</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>

      <!-- 流水ID -->
      <a-col :span="5">
        <a-row>
          <a-col :span="6" class="tool-title">流水ID：</a-col>
          <a-col :span="18">
            <a-input v-model:value="tradeNo" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>

      <!-- 查询 / 重置 -->
      <a-col :span="4" style="display: flex; justify-content: flex-end; gap: 8px;">
        <a-button type="primary" @click="handleSearch">查询</a-button>
        <a-button @click="handleReset">重置</a-button>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table class="table-view" :data-source="dataSource" :columns="columns" :row-key="record => record.id"
    :pagination="pagination" :loading="isLoading" @change="handleTableChange">
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!--价格-->
      <template v-if="column.key === 'total_amount'">
        <a-tooltip>
          <template #title>{{ record.trade_no }}</template>
          <span>{{ record.total_amount }}</span>
        </a-tooltip>
      </template>

      <!-- 支付渠道 -->
      <template v-if="column.key === 'pay_channel'">
        <span>{{ (record.pay_channel === 1) ? 'Google pay' : 'Apple pay' }}</span>
      </template>


      <!-- 界面语种 -->
      <template v-if="column.key === 'lang_name'">
        <span>{{ record.lang_name }}</span>
      </template>

      <!-- 系统 -->
      <template v-if="column.key === 'platform'">
        <span>{{ record.platform === 1 ? 'Android' : 'IOS' }}</span>
      </template>

      <!-- 购买页面 -->
      <template v-if="column.key === 'buy_place'">
        <span>{{ record[column.key] }}{{ record.eq_number !== 0 ? `【第${record.eq_number}集】` : '' }}</span>
      </template>
      <!-- 其他信息 -->
      <!-- <template v-if="column.key === 'action'">
        <a @click="handleDetail(record)">查看</a>
      </template> -->
    </template>
  </a-table>
  <Detail ref="RefDetail" />
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { Platforms, PayChannels } from '@/utils/constantList'
import dayjs from 'dayjs'
import * as Ex from "@netjoy/excelex"
import Pub from '@/utils/public'
import Detail from './components-purchase/Detail.vue'
import { purchaseList } from '@/api/admin'

// 详情抽屉
let RefDetail = ref(null)
// 加载
let isLoading = ref(false)
// 日期范围
let dateRange = ref([dayjs().subtract(30, 'day'), dayjs()])
// 日期format
const dateFormat = 'YYYY-MM-DD'
// UID
let uid = ref(undefined)
// 支付渠道
let payChannel = ref(undefined)
// 流水id
let tradeNo = ref(undefined)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '购买时间',
    dataIndex: 'pay_success_time',
    key: 'pay_success_time'
  },
  {
    title: 'UID',
    dataIndex: 'user_id',
    key: 'user_id'
  },
  {
    title: '购买内容',
    dataIndex: 'charge_content',
    key: 'charge_content'
  },
  {
    title: '价格',
    dataIndex: 'total_amount',
    key: 'total_amount'
  },
  {
    title: '支付渠道',
    dataIndex: 'pay_channel',
    key: 'pay_channel'
  },
  {
    title: '系统',
    dataIndex: 'platform',
    key: 'platform'
  },
  {
    title: '界面语种',
    dataIndex: 'lang_name',
    key: 'lang_name'
  },
  {
    title: '购买页面',
    dataIndex: 'buy_place',
    key: 'buy_place'
  },
  // {
  //   title: '其他信息',
  //   dataIndex: 'action',
  //   key: 'action'
  // }
])

// 钩子函数
onBeforeMount(() => {
  // query带入uid字段
  const route = useRoute()
  if (route.query.id) {
    uid.value = route.query.id
    // linkSource.value = route.query.source && Number(route.query.source)
  }
  // 获取购买列表
  getPurchaseList()
})

// 查询
function handleSearch() {
  pagination.current = 1
  // 获取列表
  getPurchaseList()
}

// 分页处理
function handleTableChange(p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getPurchaseList()
}

// 重置
function handleReset() {
  // 筛选项重置
  dateRange.value = null
  uid.value = undefined
  tradeNo.value = undefined
  payChannel.value = undefined
  // 分页重置
  pagination.current = 1
  getPurchaseList()
}

// 获取购买列表
function getPurchaseList() {
  isLoading.value = true
  const params = {
    start_at: dateRange.value ? `${dateRange.value[0].format(dateFormat)}` : undefined,
    end_at: dateRange.value ? `${dateRange.value[1].format(dateFormat)}` : undefined,
    uid: uid.value,
    trade_no: tradeNo.value,
    pay_channel: payChannel.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  purchaseList(params).then(res => {
    // console.log(res);
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    }
    else {
      message.error(res.message || msg)
    }
  })
}

// 查看其他信息
function handleDetail(record) {
  RefDetail.value.showDrawer(record)
}
</script>

<style scoped>
.tool-title {
  line-height: 60px;
  font-weight: 500;
}

.tool-row {
  margin-bottom: 16px;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>